module.exports = __webpack_public_path__ + "img/cmpltdsuccess.673d4930.svg";